import heading from './HeadingRenderer';
import listItem from './ListItemRenderer';
import paragraph from './ParagraphRenderer';
import table from './TableRenderer';
export default {
    heading: heading,
    listItem: listItem,
    paragraph: paragraph,
    table: table,
};
//# sourceMappingURL=index.js.map